import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "section is-large" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextImage = _resolveComponent("TextImage")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: link.link
          }, [
            _createElementVNode("h2", null, _toDisplayString(link['name']) + " = " + _toDisplayString(link['link']), 1 /* TEXT */),
            _createElementVNode("iframe", {
              src: link['link'],
              class: "iframe"
            }, null, 8 /* PROPS */, _hoisted_3),
            _hoisted_4
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createVNode(_component_TextImage, { text: '' })
    ])
  ]))
}